import { SVGProps } from "react";

// "Complete" — caja con check (estado complete).
export function CubePlayFinish(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="60" height="60" rx="6" fill="#F6FFED" />
      <path
        d="M52.3371 27.5225V21.9825C52.3403 20.6527 51.9875 19.3463 51.3153 18.199C50.6432 17.0516 49.6761 16.105 48.5146 15.4575L33.6221 7.19001C32.5143 6.57354 31.2675 6.25 29.9996 6.25C28.7318 6.25 27.485 6.57354 26.3771 7.19001L11.4846 15.455C10.3228 16.1027 9.3555 17.0497 8.68331 18.1975C8.01111 19.3454 7.65852 20.6523 7.66214 21.9825V38.0175C7.65896 39.3473 8.01177 40.6537 8.68394 41.8011C9.35611 42.9485 10.3231 43.895 11.4846 44.5425L26.3771 52.81C27.485 53.4265 28.7318 53.75 29.9996 53.75C31.2675 53.75 32.5143 53.4265 33.6221 52.81L39.9271 49.31"
        stroke="#00B578"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.8238 17.49L29.9988 30M29.9988 30L9.17383 17.49M29.9988 30V53.725M43.6638 39.99L47.1838 43.5075C47.3072 43.6333 47.4544 43.7333 47.6169 43.8016C47.7794 43.8698 47.9538 43.905 48.1301 43.905C48.3063 43.905 48.4808 43.8698 48.6433 43.8016C48.8057 43.7333 48.953 43.6333 49.0763 43.5075L56.1638 36.4175"
        stroke="#00B578"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
